module.exports = __webpack_public_path__ + "static/media/BookingImg.f814663e.png";